import React, { Suspense } from "react";
import "./App.css";
import "./styles/darkmode.css";
import SignUp from "./Pages/SignUp";
import SignIn from "./Pages/SignIn";
import Profile from "./Pages/Profile";
import Dashboard from "./Pages/Dashboard";
import Jobs from "./Pages/Jobs";
import ResetPassword from "./Pages/ResetPasssword";
import SimpleNavBar from "./Components/SimpleNavBar";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import NotFound from "./Components/NotFound";
import PermissionDenied from "./Components/PermissionDenied";
import { routes } from "./routes";
import ProtectedRoute from "./common/ProtectedRoute";
import Auth from "./common/Auth";
import Loader from "./utils/loader";
import { Provider as ReduxProvider } from "react-redux";
import store from "./store/store";
import { ThemeProviderCustom, useThemeContext } from "./context/ThemeContext";
import { getUserInfo } from "./utils/authStorage";
import ImpersonateBootstrap from "./Pages/ImpersonateBootstrap";

function AppContent() {
  const { theme } = useThemeContext();
  const id = getUserInfo();
  
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Suspense
        fallback={
          <div>
            <Loader />
          </div>
        }
      >
        <Auth>
          <BrowserRouter>
            <Routes>
              {id ? (
                <>
                  <Route path={`/profile/:userId`} element={<ProtectedRoute element={<Profile />} />} />
                </>
              ) : (
                <Route path="/" element={<SignIn />} />
              )}
              <Route path="/simplenavbar" element={<SimpleNavBar />} />
              <Route path="/signup" element={<SignUp />} />

              <Route path="/signin" element={<SignIn />} />
              <Route path="/" element={<SignIn />} />
              <Route path="/resetpassword" element={<ResetPassword />} />
              <Route path="/impersonate" element={<ImpersonateBootstrap />} />
              <Route path="/profile/:userId/dashboard" element={<ProtectedRoute element={<Dashboard />} />} />
              <Route path="/dashboard" element={<ProtectedRoute element={<Dashboard />} />} />
              <Route path="*" element={<NotFound />} />
              <Route
                path="/permission-denied"
                exact
                element={<PermissionDenied />}
              />
              <Route path="/jobs" element={<ProtectedRoute element={<Jobs />} />} />
              {routes.map(({ element, path, name, allowedRoles, alias, requiredPermission }) => (
                <React.Fragment key={name}>
                  <Route path={path} element={<ProtectedRoute element={element} roles={allowedRoles} requiredPermission={requiredPermission} />} />
                  {alias && <Route path={alias} element={<ProtectedRoute element={element} roles={allowedRoles} requiredPermission={requiredPermission} />} />}
                </React.Fragment>
              ))}
            </Routes>
          </BrowserRouter>
        </Auth>
      </Suspense>
    </ThemeProvider>
  );
}

function App() {
  return (
    <ReduxProvider store={store}>
      <ThemeProviderCustom>
        <AppContent />
      </ThemeProviderCustom>
    </ReduxProvider>
  );
}

export default App;
